import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import { ImageThumb } from 'utils/helpers';

const style = {
  width: 'auto',
  bgcolor: 'background.paper',
  p: 4,
};

const CloseModal = styled(IconButton)(({ theme }) => ({
  textDecoration: 'none',
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  color: theme.palette.primary.dark,
  '&:hover': {
    cursor: 'pointer',
  },
}));

const ArticleModal = (props) => {
  const { data, handleClose = null } = props;

  return (
    <Box sx={style}>
      <CloseModal onClick={handleClose}>
        <CloseIcon />
      </CloseModal>
      <h2 id='child-modal-title'>{data.name}</h2>
      <Grid item xs={12}>
        <Grid container direction='row' mb={2}>
          <Grid item xs={3}>
            <ImageThumb src={data.imageLink} styles={{ maxWidth: '100%', paddingRight: '15px' }} />
          </Grid>
          <Grid item xs={9} pl={1}>
            <Typography variant='p' component='div' sx={{ textAlign: 'justify' }}>
              <div dangerouslySetInnerHTML={{ __html: data.htmlText }}></div>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ArticleModal;
